// eslint-disable-next-line no-restricted-imports
import { ActivityIndicator } from 'dripsy';

export default ActivityIndicator;
